import { gql } from 'apollo-boost';

export const DECLINE_ADMIN_DATA_EXPORT = gql`
    mutation DeclineAdminDataExport($id: ID!, $reason: String) {
        declineAdminDataExport(id: $id, reason: $reason) {
            id
            status
            declinedAt
            declinedReason
            createdAt
            updatedAt
        }
    }
`;
